import Image from 'next/image'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import style from './about.module.css'


export default function AboutHeroComponent() {
    return (
        <article className='sectionOrArticleTB'>
            <div className='text-center'>
                <h1 className='caregoriesTitle'>About Fl Gold Coin Exchange</h1>
            </div>
            <article className='sectionOrArticleB'>
                <div className='imgStripContainer'>
                    <div className='imgStripText'>
                        <Image src='/images/Strip5.gif'
                            alt="Strip"
                            fill
                            sizes="(max-width: 768px) 100vw,
                      (max-width: 1200px) 50vw,
                      33vw"
                        />
                    </div>
                </div>
            </article>
            <article className='sectionOrArticleT mt-5 mt-lg-0 mt-xl-0 mt-xxl-0'>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={11} md={10} lg={9} xl={8}>
                            <div className='clearfix'>
                                <div className={`float-start ${style.imageBox}`}>
                                    <Image src='/images/ngc11.gif'
                                        alt="NGC"
                                        width={150}
                                        height={70}
                                        className={style.imageStyle}
                                    />
                                </div>
                                <p>
                                    Fl Gold Coin Exchange was established by Alex Turchak who is CEO and a director of the company.
                                    Alex is a member of the American Numismatic Association and authorized
                                    dealers of the National Guaranty Corporation (NGC).
                                </p>
                                <p>FL Gold Coin Exchange specializes in Foreign coins, medals and paper money.
                                    Our inventory includes hard to find rare world coins and banknotes and is updated on weekly basis.
                                    All the items we list are guaranteed to be genuine. You can buy with confidence as we have
                                    14 day unconditional return privilege.
                                </p>
                                <p>
                                    We also sell Investment Quality Gold, Silver and Platinum Bullion Coins and Bars in
                                    a variety of different shapes, sizes, and minted by several highly reputable producers.
                                    Premiums above the spot price of Gold/Silver/Platinum is much lower on  bullion items than
                                    on numismatic, or rare coins.
                                </p>

                                <p>
                                    We have been paying top prices for quality world coins, medals and banknotes.
                                    Please, contact us for current prices on nearly any precious metal product. We are also open for trading
                                    All purchases and sales are private to protect your confidentiality. Your information will
                                    never be shared with others.
                                </p>
                                <p className="italic">When dealing with FL Gold Coin Exchange, you can rest assured that you are doing
                                    business with professionals, who have 40 years of experience in the industry.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </article>
        </article>
    )
}